"use client";
import { forwardRef } from "react";
import { SelectBase } from "./SelectBase.js";
const MultiSelect = forwardRef(function MultiSelect2(props, ref) {
  return SelectBase(props, true, ref);
});
export {
  MultiSelect
};
